'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  optionsList: {
    backgroundColor: _reactackleCore.colorWhite,
    paddingY: _reactackleCore.halfBaseModule,
    paddingX: 0,
    borderRadius: _reactackleCore.radiusDefault,
    minWidth: 140,
    maxWidth: '100vw'
  },

  option: {
    fontSize: _reactackleCore.fontSizeBody,
    textTransform: 'none',
    lineHeight: 1.5, // Only number accepted
    paddingY: _reactackleCore.halfBaseModule,
    paddingX: _reactackleCore.oneAndHalfBaseModule,
    borderRadius: 0,

    style: {
      fontColor: _reactackleCore.bodyFontColor,
      backgroundColor: _reactackleCore.colorTransparent,
      fontWeight: _reactackleCore.fontWeightNormal,

      hover: {
        fontColor: _reactackleCore.bodyFontColor,
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        fontWeight: _reactackleCore.fontWeightNormal
      },

      focus: {
        fontColor: _reactackleCore.bodyFontColor,
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        fontWeight: _reactackleCore.fontWeightNormal
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-input-autocomplete/dist/styles/theme.js
// module id = 730
// module chunks = 0